module Meevo.Plugins.MembershipManager {
    "use strict";

    import IMemberBenefitTemplateDiscountItem = Meevo.Model.MemberBenefitTemplateDiscountItem;
    import AccruedServiceSharingEnum = Meevo.Model.AccruedServiceSharingEnum;
    import FreezeSettingEnum = Meevo.Model.FreezeSettingEnum;

    /**
    * Section
    */
    export class BenefitsSection extends MembershipBaseSection {
        public disableCrud: boolean = true;
        private viewModel: any = {};
        private benefitsType: any = 0;
        private _freezeSettingList = {
            [FreezeSettingEnum.AccruedServiceOnly]: 'LABEL_ACCRUED_SERVICES_ONLY',
            [FreezeSettingEnum.FullAccess]: 'LABEL_FULL_ACCESS?',
            [FreezeSettingEnum.MemberBenefitsOnly]: 'LABEL_MEMBER_BENEFITS_ONLY',
            [FreezeSettingEnum.NoAccess]: 'LABEL_NO_ACCESS',
        };
        private _accruedServiceSharingList = {
            [AccruedServiceSharingEnum.NoSharing]: 'LABEL_ACCRUED_SERVICE_SHARING_ENUM_NOSHARING',
            [AccruedServiceSharingEnum.OnlyDefinedUsers]: 'LABEL_ACCRUED_SERVICE_SHARING_ENUM_ONLYDEFINEDUSERS',
            [AccruedServiceSharingEnum.FamilyOnly]: 'LABEL_ACCRUED_SERVICE_SHARING_ENUM_FAMILYONLY',
            [AccruedServiceSharingEnum.Anyone]: 'LABEL_ACCRUED_SERVICE_SHARING_ENUM_ANYONE'
        };
        
        changeViewModel(): void {
            if (this.benefitsType === 0) {
                this.viewModel = this.model['primaryMemberBenefit'];
            } else {
                this.viewModel = this.model['secondaryMemberBenefit'];
            }

            this.viewModel.generalInfo = this.viewModel.generalInfo ? this.viewModel.generalInfo : {};
            let info = this.viewModel.generalInfo;
            info.serviceDiscount = info.serviceDiscount ? Math.floor(info.serviceDiscount * 100) : 0;
            info.productDiscount = info.productDiscount ? Math.floor(info.productDiscount * 100) : 0;
            info.packageDiscount = info.packageDiscount ? Math.floor(info.packageDiscount * 100) : 0;

            this.model['accruedServiceSharing'] = this._accruedServiceSharingList[this.model['accruedServiceSharingEnum']];

            _.each(this.model['membershipFreezeSettings'], (item: Model.IMembershipFreezeSetting) => {
                item.displayName = this._freezeSettingList[item.freezeSetting];
            });
            
        };

        public sectionModelRetrieved(): void {
            super.sectionModelRetrieved();
            this.changeViewModel();
        }

        updateTabData(): void {
            this.changeViewModel();
        }
    }
}